import { render, staticRenderFns } from "./cmpconsultaprodutosnotafor.vue?vue&type=template&id=7f420cc5&"
import script from "./cmpconsultaprodutosnotafor.vue?vue&type=script&lang=js&"
export * from "./cmpconsultaprodutosnotafor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports